<template>
  <div class="public-panel">
    <img src="@/assets/images/header-logo-white.svg" />

    <div class="form">
      <div v-if="forgot" class="forgot-password">
        <div class="row">
          <h4 class="title">Forgot Password</h4>
          <p @click="togglePassword">
            <i class="fa fa-angle-left" />Back
          </p>
        </div>

        <md-field :class="{'input-error': $v.email.$error || errorMsg}">
          <label>Email</label>
          <md-input v-model="email" @blur="$v.email.$touch()" @keyup.enter="forgotPassword" type='email' />
        </md-field>
        <h6 class="error-message" v-if="$v.email.$error && !$v.email.required">Please enter Email</h6>
        <h6 class="error-message" v-else-if="$v.email.$error && !$v.email.email">Please enter valid Email</h6>
        <h6 class="error-message" v-else-if="errorMsg">{{errorMsg}}</h6>

        <button @click="forgotPassword">Send Reset Password Link</button>
      </div>

      <div v-else>
        <h4 class="title">Sign In</h4>

        <md-field :class="{'input-error': $v.email.$error}">
          <label>Email</label>
          <md-input v-model="email" @blur="$v.email.$touch()" type='email' />
        </md-field>
        <h6 class="error-message" v-if="$v.email.$error && !$v.email.required">Please enter Email</h6>
        <h6 class="error-message" v-else-if="$v.email.$error && !$v.email.email">Please enter valid Email</h6>

        <md-field :class="{'input-error': $v.password.$error}">
          <label>Password</label>
          <md-input v-model="password" type="password" @blur="$v.password.$touch()"
                    @keyup.enter="login" />
        </md-field>
        <h6 class="error-message" v-if="$v.password.$error && !$v.password.required">Please enter Password</h6>
        <h6 class="error-message" v-else-if="$v.password.$error && !$v.password.minLength">Please enter minimum {{$v.password.$params.minLength.min}} characters</h6>

        <h6 class="error-message" v-if="errorMsg">{{errorMsg}}</h6>
        <p class="info-options" @click="togglePassword">Forgot Password?</p>

        <button @click="login">Login</button>
      </div>
    </div>

    <promotion-banner />
  </div>
</template>

<script>
import ApiServices from '@/services/api'
import { email, required, minLength } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'
import PromotionBanner from '@/components/global/PromotionBanner'

export default {
  components: { PromotionBanner },
  name: 'Login',
  data () {
    return {
      email: null,
      password: null,
      errorMsg: null,
      forgot: false
    }
  },
  validations: {
    email: {
      email,
      required
    },
    password: {
      required,
      minLength: minLength(8)
    }
  },
  watch: {
    email () {
      this.errorMsg = null
    },
    password () {
      this.errorMsg = null
    }
  },
  methods: {
    ...mapMutations(['SET_USER_LOGGED_IN', 'SET_TARGET_PAGE']),
    login () {
      this.$v.$touch()
      if (!this.$v.$error) {
        if (localStorage.getItem('access_token')) {
          this.SET_USER_LOGGED_IN()
          this.SET_TARGET_PAGE()
          this.successToastMsg('User already Logged In')
          this.$router.push({name: 'Dashboard'})
        } else {
          let params = {
            email: this.email,
            password: this.password,
            device_os: navigator.userAgent,
            device_app: navigator.appName
          }

          this.loginApi(params)
        }
      }
    },
    loginApi (params) {
      ApiServices.login(params).then((response) => {
        let data = response.data
        localStorage.setItem('access_token', data.token)
        this.SET_USER_LOGGED_IN(true)

        if (data.next_page === 'DASHBOARD') {
          this.SET_TARGET_PAGE('ANY')
          this.$router.push({name: 'Dashboard'})
        } else if (data.next_page === 'OTP') {
          this.SET_TARGET_PAGE('OTP')
          this.$router.push({name: 'OTP'})
        } else {
          this.SET_TARGET_PAGE('OTP_SETUP')
          this.$router.push({name: 'OTPSetup'})
        }

        window.gtag('event', 'conversion', {'send_to': 'AW-705039016'})
      }).catch((error) => {
        this.errorMsg = error.body.message
      })
    },
    openSignup () {
      this.$router.push({name: 'Signup'})
    },
    togglePassword () {
      this.errorMsg = null
      this.forgot = !this.forgot
    },
    forgotPassword () {
      this.$v.email.$touch()
      if (!this.$v.email.$error) {
        ApiServices.forgotPassword({email: this.email}).then((response) => {
          this.successToastMsg(response.message)
          this.forgot = false
        }).catch((error) => {
          this.errorMsg = error.body.message
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/publicPanel.scss';

  .public-panel {
    .forgot-password {
      .row {
        @include custom-flex(space-between);

        p {
          @include normal-text($primary, 14px);
          cursor: pointer;

          .fa {
            margin-right: 5px;
          }
        }
      }
    }
  }
</style>
